import {Container, Snackbar} from "@mui/material";
import ReactMarkdown from "react-markdown";
import React, {useEffect, useState} from "react";
import {emailApplicationContract, gql, queryApplicationWithContracts} from "../../db/model";
import {useDispatch, useSelector} from "react-redux";
import {selectApplicationContracts, selectUser} from "../../db/selectors";
import {useParams} from "react-router-dom";
import {EmailOutlined, InsertDriveFileOutlined} from "@mui/icons-material";
import {BackButton} from "../../components/@FreeModel";

export const ContractorAgreement = () => {
  const dispatch = useDispatch()
  const {applicationID} = useParams()
  const contracts = useSelector(selectApplicationContracts)
  const user = useSelector(selectUser)
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // @ts-ignore
    dispatch(gql({
      query: queryApplicationWithContracts,
      variables: {id: applicationID},
    }))
  }, [dispatch, applicationID]);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    setOpen(false);
  }

  const rows = []
  if (contracts) {
    for (let i = 0; i < contracts.length; i++) {
      const contract = contracts[i]
      if (contract.contractType !== 'MasterContractorAgreement') {
        continue
      }

      const onClick = () => {
        // @ts-ignore
        dispatch(gql({
          query: emailApplicationContract,
          variables: {id: applicationID},
          onSuccess: (newState) => setOpen(true)
        }))
      }

      rows.push(<div>
        <div className="email-icon-link" style={{margin: '16px 0'}} onClick={onClick}>
          <EmailOutlined className="email-icon"/>
          <span>Send as Email</span>
        </div>
        <ReactMarkdown>{contract.contractText ?? ''}</ReactMarkdown>
      </div>)
    }
  }

  return <Container className="contract">
    <h3 style={{fontSize: '20px', marginTop: '8px'}}>Freemodel Contractor Agreement</h3>
    <BackButton to={`/contractors/${applicationID}/tax-info/individual/review`}/>
    {rows}
    <Snackbar
      open={open}
      autoHideDuration={5000}
      anchorOrigin={{vertical: "bottom", horizontal: "center"}}
      onClose={handleClose}
      message={`Email sent to ${user.primaryEmail}`}
    />
  </Container>
}